<template>
  <div
    class="sidebar"
    :class="{'sidebar_hidden' : !showSidebar}"
  >
    <transition
      name="slide-fade"
    >
      <div
        v-if="showSidebar"
        class="freight-order__navigation"
      >
        <div
          v-for="item in documentNav"
          :key="item.id"
          class="navigation__list"
        >
          <a
            v-if="item.show"
            :key="item.text"
            :href="item.href"
            class="navigation__link"
          >
            {{ $t(item.text) }}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LeftSideBar',
  props: {
    showSidebar: Boolean,
    documentNav: Array,
  },
};
</script>

<style lang="scss" scoped>
  .sidebar {
    flex: 1;
    position: relative;
    background-color: #F4F8FA;
    border-right: 2px solid #E0E6EE;
    transition: flex 0.6s ease;
    @media(max-width: 992px) {
      flex: 0;
      width: 0;
      overflow: hidden;
    }
  }

  .freight-order__navigation {
    display: flex;
    position: fixed;
    flex-direction: column;
    row-gap: 12px;
    padding-top: 10vh;
    height: 100%;
    list-style: none;
    font-weight: 600 !important;
    .navigation__link {
      font-size: 10px;
    }
    @media(max-width: 1930px) {
      width: 14rem;
      padding-left: 3vw;
    }
    @media(max-width: 1400px) {
      row-gap: 5px;
      width: 12rem;
      padding-left: 2vw;
    }
    @media(max-width: 1250px) {
      width: 10rem;
      padding-left: 2vw;
    }
    @media(max-width: 992px) {
      display: none;
    }
  }
  .sidebar_hidden {
    flex: 0;
  }

  .slide-fade-active .navigation__list {
    transition: all 0.3s ease-in-out;
    transition-delay: 0.25s;
  }

  .slide-fade-enter-from .navigation__list,
  .slide-fade-leave-to .navigation__list {
    transform: translateX(30px);
    opacity: 0.001;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(-20px);
    opacity: 0;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-fade-leave-active {
    transition-delay: 0.25s;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }

  .slide-fade-enter-active .navigation__list,
  .slide-fade-leave-active .navigation__list {
    transition: all 0.3s ease-in-out;
  }

  .slide-fade-enter-active .navigation__list {
    transition-delay: 0.25s;
  }

  .slide-fade-enter-from .navigation__list,
  .slide-fade-leave-to .navigation__list {
    transform: translateX(-30px);
    opacity: 0.001;
  }

</style>
